module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edo-popup"
  }, [(_vm.layout === 'edo') ? _c('div', {
    staticClass: "edo-layout"
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "edo-content"
  }, [_c('h3', [_vm._v("Thanks for protecting the Unburnt Six!")]), _vm._v(" "), _c('p', [_vm._v("\n        Defending these precious habitats is crucial in the fight against\n        extinction. Your voice is vital to ensuring they are protected.\n      ")]), _vm._v(" "), _c('h4', [_vm._v("Take the next step with EDO")]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.edoDonateUrl
    }
  }, [_vm._v("Donate to EDO")])]), _vm._v(" "), _vm._m(3, false, false)]) : _vm._e(), _vm._v(" "), (_vm.layout === 'wwf') ? _c('div', [_vm._m(4, false, false), _vm._v(" "), _vm._m(5, false, false)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edo-header-img"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2903/dist/assets/img/edo-popup-header.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Environmental Defenders Office is at the forefront of the legal battle\n        to protect our wildlife, climate and communities.\n        "), _c('span', [_vm._v("But winning this fight depends on people like you.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "edo-close popup-close-button",
    attrs: {
      "data-close": "",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "popup-close-button-span"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-header"
  }, [_c('div', {
    staticClass: "popup-header-logo"
  }, [_c('img', {
    staticClass: "popup-logo",
    attrs: {
      "src": "https://www.wwf.org.au/ecThemes/3/Images/wwf-logo.svg"
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "popup-close-button",
    attrs: {
      "data-close": "",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "popup-close-button-span"
  }, [_vm._v("Close")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-content"
  }, [_c('h3', [_vm._v("Thank you. Every signature speaks volumes.")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/images/UserUploadedImages/403/img-koalas-thumbnail.jpg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Want to make a bigger impact?")]), _vm._v("Australia has the worst mammal extinction rate of any country in the\n          world, and with last year’s bushfires having pushed so many more\n          species to the brink of extinction, our wildlife urgently needs your\n          help, now more than ever.\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Your generosity today will help those remaining survive by\n          protecting their forest homes.\n          "), _c('br'), _vm._v("Thank you.\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "bttn-mdm-arrw",
    attrs: {
      "href": "http://donate.wwf.org.au/donate/one-off-donation/defending-the-unburnt-six"
    }
  }, [_vm._v("DONATE TODAY")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Take part in the #DefendTheUnburnt video!")]), _vm._v("Make your voice heard. Help us amplify our collective voice and be\n          part of a WWF video to defend the Unburnt Six.\n          "), _c('a', {
    attrs: {
      "href": "https://www.wwf.org.au/what-we-do/2-billion-trees/defending-the-unburnt-six/submit-video/submit-video"
    }
  }, [_vm._v("Click here to upload your video")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdf3681e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=ba0n6m0pdol!./~/string-replace-webpack-plugin/loader.js?id=vjdso5oqwij!./src/components/forms/EdoPopup.vue
// module id = 688
// module chunks = 0